var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"sd-comments list-unstyled"},_vm._l((_vm.comments),function(thisComment){return _c('comment',{key:thisComment.id,attrs:{"comment_id":thisComment.id}})}),1),_vm._v(" "),(_vm.isLoggedIn)?_c('post-comment'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }